import styled from 'styled-components';
import { COLOR } from '../../styles/colors';

interface IStyledCheckboxLabelProps {
  $isDisabled?: boolean;
}

export const StyledCheckboxLabel = styled.label<IStyledCheckboxLabelProps>`
  display: inline-flex;
  align-items: center;

  cursor: ${({ $isDisabled }) => ($isDisabled ? 'default' : 'pointer')};
`;

export const StyledSelectAllCheckbox = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
`;

interface IStyledVisibleCheckboxProps extends IStyledCheckboxLabelProps {
  $size: number;
  $isChecked?: boolean;
}

export const StyledVisibleCheckbox = styled.span<IStyledVisibleCheckboxProps>`
  display: flex;
  align-items: center;
  justify-content: center;

  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;

  background: ${({ $isDisabled, $isChecked, theme }) =>
    $isDisabled
      ? COLOR.neutral5
      : $isChecked
      ? theme.colors.other.link
      : COLOR.white};

  box-sizing: border-box;
  border-radius: 4px;
  border: solid 1px
    ${({ $isChecked, theme }) =>
      $isChecked ? theme.colors.other.link : COLOR.neutral10};
  transition: all 150ms;
`;

export const StyledHiddenCheckbox = styled.input.attrs<
  React.HTMLProps<HTMLInputElement>
>({
  type: 'checkbox'
})`
  position: absolute;

  margin: -1px;
  padding: 0;
  border: 0;

  height: 1px;
  width: 1px;

  white-space: nowrap;
  overflow: hidden;

  clip: rect(0 0 0 0);
  clip-path: inset(50%);

  :focus + ${StyledVisibleCheckbox} {
    outline-style: solid;
  }
`;
